import { EnvironmentProfile } from '../app/models/environment-profile.enum';

export const environment = {
  production: false,
  profile: EnvironmentProfile.DEVELOPMENT,
  apiBasePath: '/colimoUser',
  apiTrendAnalysisPath: '/colimoWsTrendsCollector',
  apiVersionPath: '/api/v1',
  apiUserPath: '/u',
  mimeType: '.json',
  adminPath: '/admin/',
  baseAuthPath: '/auth',
  minimalValidationTimeLeftInSeconds: 7200,
  loginRoute: '',
  routeAfterLogin: '/color',
  defaultLanguage: 'en',
  languageParameter: 'language',
  showNewCarReport: true,
  showTrendAnalysisResults: true,
  trendAnalysisMaxPredictionDays: 60,
  trendAnalysisWeeklyThreshold: 9,
  colorCareRoute: 'colorCareLogin',
  colorCareLoginUrl: 'https://dev.color.basf.com/apps',
  colorCareEvoUserUrl: 'https://dev.db.colorcare.basf.com/eu/user',
  colorCareCloudStorageServiceUrl: "https://dev.db.colorcare.basf.com/eu/storage",
  contactUrl:'https://dev.color.basf.com/de/contact',

  loginRedirection: {
    enabled: false,
    auto: true,
  },

  dashboard: {
    init: 'dashboard',
    add: 'dashboard/add',
    connectProject: 'dashboard/connectProject?',
    disconnectProject: 'dashboard/disconnectProject?',
    customerLines: 'dashboard/customerLines',
    customerModels: 'dashboard/customerModels',
  },

  search: {
    all: 'search',
  },

  project: {
    all: 'project',
    headerById: 'project/header/{projectId}',
    updateBatchStateByProductId: 'project/updateBatchStateForProduct/{productId}',
    byId: 'project/{projectId}',
    projectPageSize: 4,
    tolerancesById: 'project/tolerances/{projectId}',
    tolerancesByBatchId: 'project/tolerancesByBatchId/{batchId}',
  },

  batches: {
    all: 'batch',
    byProjectId: 'batch/project/{projectId}',
    header: 'batch/header/{batchId}/{lineNumber}',
    forecastById: 'batch/forecast/{batchId}',
    updateForecastByBatchId: 'u/ccng/updateForecastBatchId',
    updateRetainMeasurementsByBatchId: 'u/ccng/updateRetainMeasurements',
    updateLabMeasurements: 'u/ccng/updateLabMeasurements',
    forecastMeasurementsByBatchId: 'batch/forecastMeasurements/{batchId}',
    retainMeasurementsByBatchId: 'batch/retainMeasurements/{batchId}',
  },

  kpis: {
    byLine: 'kpi/batch/{batchId}/line/{lineNumber}',
  },

  charts: {
    mwg: 'batch/{batchId}/line/{lineId}/data-avg-filtered',
    fdg: 'batch/{batchId}/line/{lineId}/data-diff',
    fog: 'batch/{batchId}/line/{lineNumber}/data-pos',
    deg: 'batch/{batchId}/line/{lineNumber}/data-diff-abstractde',
    lpg: 'batch/{batchId}/line/{lineNumber}/data-lpg',
    modelsComponents: 'batch/{batchId}/line/{lineNumber}/models-components',
    vid: 'vid-cnt-red-yellow-multi-batch',
    vidIds: 'vid-vehicle-ids',
    mwgQC: 'batch/{batchId}/line/{lineId}/measurement/{measurementId}/data-avg-qc',
    mwgQCWithReference: 'batch/{batchId}/line/{lineId}/measurement/{measurementId}/reference/data-avg-qc',
    mwgForVectorTheory: 'vector/batch/{batchId}/line/{lineId}/theory/reference/data-avg-qc',
  },

  reports: {
    customers: 'lookupKeyText?lstaNr=0&typ=KUND&lang=EN',
    locations: 'lookupKeyText?lstaNr=0&typ=LSTA&lang=EN',
    carTypes: 'lookupKeyText?lstaNr={lstaNr}&typ=CAR&lang=EN',
    locationLines: 'lookupLstaLines?kundNr={customerId}',
    colors: 'lookupColors?lstaNr={locationId}',
    colorProducts: 'lookupColorProducts?kundNr={customerId}',
    kpiReport:
      'kpiReport?kundNr={customerId}&lines={lines}&products={products}&kpis={kpis}&startDate={startDate}&endDate={endDate}',
    carStatus: 'carStatus/{lstaNr}?carId={carId}',
    carStatusSearch: 'carStatus/search/{lstaNr}?carId={carId}',
    carBodyStyle: 'carStatus/outline?carBodyStyleId={carBodyStyleId}',
    uploadSingleCar: 'carStatus/uploadSingleCarMeasurementFile?cartype={cartype}&colorId={colorId}&lstaNr={lstaNr}',
    uploadSingleCarDownloadXlsx:
      'carStatus/uploadSingleCarMeasurementFileDownloadXlsx?cartype={cartype}&colorId={colorId}&lstaNr={lstaNr}',
    components: 'lookupKeyText?lstaNr=0&typ=PART&lang={language}',
    position: 'lookupKeyText?lstaNr=0&typ=POINT&lang={language}',
  },

  trendAnalysis: 'predictions/batch/{batchId}/line/{lineId}/indicator/{indicator}',

  backendInfo: 'serverInfo',

  tinterAdditions: 'tinterAdditions?batchId={batchId}&line={line}',
  tinterAdditionsCount: 'tinterAdditions/count?batchId={batchId}&line={line}',

  exportToClipboard: {
    exportFMCCTBClipboardMeanValues: 'exportFMCCTBClipboardMeanValues',
    exportFMCCTBClipboardMeasurements:
      'exportFMCCTBClipboardMeasurements',
  },

  linkToClipboard: {
    linkToFMCCTBClipboardMeasurements:
      'linkToFMCCTBClipboardMeasurements',
    linkToFMCCTBClipboardMeanValues: 'linkToFMCCTBClipboardMeanValues',
  },

  contactPage: {
    contactEmail: 'DigitalBusinessSolutionsEMEA@basf.com',
  },

  colimind: {
    colimindActive: true,
    baseUrl: '/colimind',
    apiVersionPath: 'api/v1',
    chatStreamPath: '/maui/response/stream'
  }
};
